import './student-leave-info.scss';

export default class StudentLeaveInfoController {
  constructor(
    $scope, $mdDialog, student
  ) {
    'ngInject';
    this.$scope = $scope;
    this.$mdDialog = $mdDialog;
    this.student = {...student};
  }

  closeDialog() {
    this.$mdDialog.hide();
  }
}
